<template>
  <action-modal-wizard
    ref="modal"
    title="One time ACH Interest Payment Request"
    modalIdPrefix="achpayment-"
    :loan="loan"
    @form-completed="submit"
    @modal-hidden="onModalHidden"
  >
    <tab-content title="Payment Request" :before-change="validateAchPaymentRequest">
      <vue-form-generator
        :model="model"
        :schema="form.schema"
        :options="form.options"
        ref="achPaymentForm"
      />
      <payment-form
        ref="paymentForm"
        :loan="loan"
        :show-account-type-field="true"
        :show-option-field="false"
        :exclude-payment-method-type="['ach']"
        payment-method-type="ACH"
        @selected-payment-method="model.paymentMethod = $event.id"
      />
    </tab-content>

    <tab-content title="Additional Files">
      <additional-files-form
        ref="additionalForm"
        headline="
          If you have any additional files that you would like to
          submit with this request, please use the box below to do so.
        "
      />
      <pdf-signature ref="achPaymentSignature" title="One time ACH Interest Payment Request"/>
    </tab-content>
  </action-modal-wizard>
</template>

<script>
import helper from '@/libs/helper';

import { TabContent } from 'vue-form-wizard';
import FORM_SCHEMA from '@/components/my_deals/actions/ach_payment/resources/schema';
import ActionModalWizard from '@/components/my_deals/actions/ActionModalWizard';
import AdditionalFilesForm from '@/components/my_deals/actions/AdditionalFilesForm';
import PaymentForm from '@/components/payments/create/PaymentForm';
import PdfSignature from '@/components/utils/PdfSignature';


export default {
  components: {
    ActionModalWizard,
    TabContent,
    AdditionalFilesForm,
    PaymentForm,
    PdfSignature,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      model: this.getCleanedForm(),
      form: {
        schema: FORM_SCHEMA.schema(),
        options: FORM_SCHEMA.options,
      },
      achPaymentToSign: String,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    validateAchPaymentRequest() {
      // split up in const each validation for validate all the forms at once
      const achFormValidated = this.$refs.achPaymentForm.validate();
      const paymentFormValidated = this.$refs.paymentForm.validate();
      return achFormValidated && paymentFormValidated;
    },
    getCleanedForm() {
      return {
        paymentMethod: null,
        authorizedAmount: null,
        authorized: false,
      };
    },
    onModalHidden() {
      this.model = this.getCleanedForm();
      this.$refs.paymentForm.reset();
      this.$refs.additionalForm.reset();
    },
    submit() {
      const data = [];
      data.payment = helper.copy(this.model);
      this.$refs.additionalForm.model.files.forEach(file => data.push(file));

      /* eslint no-underscore-dangle:  ["error", { "allow": ["_id"] }] */
      this.$reqs.uploadAssetManagement(`/users/${this.$store.getters.user.id}/loans/${this.loan._id}/ach_payment`, data)
        .then((response) => {
          this.$emit('ach-payment-sent', response);
          this.hide();
          this.achPaymentToSign = response.data.docusign_url_embedded_signature;
          this.$refs.achPaymentSignature.show(this.achPaymentToSign);
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/ach_payment/AchPaymentWizardModal.vue